import { FunctionComponent, SVGProps } from 'react';
import { ReactComponent as Cosco } from '../../assets/service-logos/cosco.svg';
import { ReactComponent as Evergreen } from '../../assets/service-logos/evergreen.svg';
import { ReactComponent as YangMing } from '../../assets/service-logos/yangming.svg';
import { ReactComponent as Pil } from '../../assets/service-logos/pil.svg';
import { ReactComponent as Msc } from '../../assets/service-logos/msc.svg';
import { ReactComponent as Hl } from '../../assets/service-logos/hl.svg';
import { ReactComponent as Hmm } from '../../assets/service-logos/hmm.svg';
import { ReactComponent as CmaCgm } from '../../assets/service-logos/cma-cgm.svg';

import maersk from '../../assets/service-logos/maersk.png';
import oocl from '../../assets/service-logos/oocl.png';
import vuxx from '../../assets/service-logos/vuxx.png';
import zim from '../../assets/service-logos/zim.png';

type Logos = {
  [key: string]: FunctionComponent<SVGProps<SVGSVGElement>>;
};

const logos: Logos = {
  cosco: Cosco,
  evergreen: Evergreen,
  'yang-ming': YangMing,
  pil: Pil,
  hmm: Hmm,
  'hapag-lloyd': Hl,
  hl: Hl,
  msc: Msc,
  'cma-cgm': CmaCgm,
  hlcl: Hl,
  maersk: ({ className }) => (
    <img src={maersk} alt="maersk" className={className} />
  ),
  oocl: ({ className }) => <img src={oocl} alt="oocl" className={className} />,
  vuxx: ({ className }) => <img src={vuxx} alt="vuxx" className={className} />,
  zim: ({ className }) => <img src={zim} alt="zim" className={className} />,
};

interface ArmadorIconProps {
  armador: string;
  className?: string;
}

export const ArmadorIcon: React.FC<ArmadorIconProps> = ({
  armador,
  className,
}) => {
  const armadorFormated = armador?.toLowerCase()?.trim();

  const Icon = logos[armadorFormated];

  return Icon ? (
    <Icon className={className} />
  ) : (
    <div className={className}>{armador}</div>
  );
};
